/**
 * CardWithdraw — куда вывести деньги с карты (Flow step="card_withdraw"). Первым — возврат на
 * рублёвый счёт, дальше внешние способы в порядке из ТЗ: SWIFT, зарубежная карта, криптовалюта.
 *
 * SWIFT и зарубежная карта уходят в общий экран вывода (заявку исполняет оператор), крипта —
 * отдельная операция карты: конвертация с выводом одним действием. Пропсы: card, onPick.
 */
import { useBackButton } from "@/telegram/useMainButton";
import { Screen } from "@/components/Screen";
import type { IssuedCard } from "@/lib/api";

export type CardWithdrawTarget = "account" | "swift" | "card" | "crypto";

const TARGETS: { key: CardWithdrawTarget; icon: string; title: string; subtitle: string }[] = [
  { key: "account", icon: "🏦", title: "На внутренний счёт в рублях", subtitle: "Мгновенно, по текущему курсу" },
  { key: "swift", icon: "🏛️", title: "SWIFT-перевод", subtitle: "Международный банковский перевод" },
  { key: "card", icon: "💳", title: "Зарубежная карта", subtitle: "Перевод на карту иностранного банка" },
  { key: "crypto", icon: "🪙", title: "Криптовалюта", subtitle: "USDT в сети TRC20, курс 1:1" },
];

export function CardWithdraw({
  card,
  onPick,
  onBack,
}: {
  card: IssuedCard;
  onPick: (target: CardWithdrawTarget) => void;
  onBack: () => void;
}) {
  useBackButton(onBack);
  return (
    <Screen title="Вывод с карты" subtitle="Выберите, куда отправить деньги">
      <div className="mb-4 rounded-2xl border border-white/[0.06] bg-surface-card px-4 py-3 text-center">
        <div className="text-[12px] text-white/45">Доступно на карте</div>
        <div className="mt-0.5 text-[22px] font-semibold tabular-nums">${card.balance_usd.toFixed(2)}</div>
      </div>
      <div className="space-y-2.5">
        {TARGETS.map((t) => (
          <button
            key={t.key}
            onClick={() => onPick(t.key)}
            className="flex w-full items-center gap-3 rounded-2xl border border-white/[0.06] bg-surface-card px-4 py-4 text-left active:bg-white/[0.03]"
          >
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand/15 text-[20px]">{t.icon}</span>
            <span className="min-w-0 flex-1">
              <span className="block text-[15px] font-medium">{t.title}</span>
              <span className="block text-[13px] text-white/45">{t.subtitle}</span>
            </span>
            <span className="shrink-0 text-brand">›</span>
          </button>
        ))}
      </div>
    </Screen>
  );
}
